// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface V1ShowDatabasesStatus
 */
export interface V1ShowDatabasesStatus {
  /**
   *
   * @type {string}
   * @memberof V1ShowDatabasesStatus
   */
  access?: string;
  /**
   *
   * @type {string}
   * @memberof V1ShowDatabasesStatus
   */
  address?: string;
  /**
   *
   * @type {Array<string>}
   * @memberof V1ShowDatabasesStatus
   */
  aliases?: Array<string>;
  /**
   *
   * @type {number}
   * @memberof V1ShowDatabasesStatus
   */
  currentPrimariesCount?: number;
  /**
   *
   * @type {number}
   * @memberof V1ShowDatabasesStatus
   */
  currentPropertyShardReplicas?: number;
  /**
   *
   * @type {number}
   * @memberof V1ShowDatabasesStatus
   */
  currentSecondariesCount?: number;
  /**
   *
   * @type {string}
   * @memberof V1ShowDatabasesStatus
   */
  currentStatus?: string;
  /**
   *
   * @type {string}
   * @memberof V1ShowDatabasesStatus
   */
  databaseID?: string;
  /**
   *
   * @type {boolean}
   * @memberof V1ShowDatabasesStatus
   */
  _default?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof V1ShowDatabasesStatus
   */
  home?: boolean;
  /**
   *
   * @type {number}
   * @memberof V1ShowDatabasesStatus
   */
  lastCommittedTxn?: number;
  /**
   *
   * @type {string}
   * @memberof V1ShowDatabasesStatus
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof V1ShowDatabasesStatus
   */
  options?: string;
  /**
   *
   * @type {number}
   * @memberof V1ShowDatabasesStatus
   */
  replicationLag?: number;
  /**
   *
   * @type {number}
   * @memberof V1ShowDatabasesStatus
   */
  requestedPrimariesCount?: number;
  /**
   *
   * @type {number}
   * @memberof V1ShowDatabasesStatus
   */
  requestedPropertyShardReplicas?: number;
  /**
   *
   * @type {number}
   * @memberof V1ShowDatabasesStatus
   */
  requestedSecondariesCount?: number;
  /**
   *
   * @type {string}
   * @memberof V1ShowDatabasesStatus
   */
  requestedStatus?: string;
  /**
   *
   * @type {string}
   * @memberof V1ShowDatabasesStatus
   */
  role?: string;
  /**
   *
   * @type {string}
   * @memberof V1ShowDatabasesStatus
   */
  serverID?: string;
  /**
   *
   * @type {string}
   * @memberof V1ShowDatabasesStatus
   */
  statusMessage?: string;
  /**
   *
   * @type {string}
   * @memberof V1ShowDatabasesStatus
   */
  store?: string;
  /**
   *
   * @type {string}
   * @memberof V1ShowDatabasesStatus
   */
  type?: string;
  /**
   *
   * @type {boolean}
   * @memberof V1ShowDatabasesStatus
   */
  writer?: boolean;
}

/**
 * Check if a given object implements the V1ShowDatabasesStatus interface.
 */
export function instanceOfV1ShowDatabasesStatus(
  value: object,
): value is V1ShowDatabasesStatus {
  return true;
}

export function V1ShowDatabasesStatusFromJSON(
  json: any,
): V1ShowDatabasesStatus {
  return V1ShowDatabasesStatusFromJSONTyped(json, false);
}

export function V1ShowDatabasesStatusFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1ShowDatabasesStatus {
  if (json == null) {
    return json;
  }
  return {
    access: json['Access'] == null ? undefined : json['Access'],
    address: json['Address'] == null ? undefined : json['Address'],
    aliases: json['Aliases'] == null ? undefined : json['Aliases'],
    currentPrimariesCount:
      json['CurrentPrimariesCount'] == null
        ? undefined
        : json['CurrentPrimariesCount'],
    currentPropertyShardReplicas:
      json['CurrentPropertyShardReplicas'] == null
        ? undefined
        : json['CurrentPropertyShardReplicas'],
    currentSecondariesCount:
      json['CurrentSecondariesCount'] == null
        ? undefined
        : json['CurrentSecondariesCount'],
    currentStatus:
      json['CurrentStatus'] == null ? undefined : json['CurrentStatus'],
    databaseID: json['DatabaseID'] == null ? undefined : json['DatabaseID'],
    _default: json['Default'] == null ? undefined : json['Default'],
    home: json['Home'] == null ? undefined : json['Home'],
    lastCommittedTxn:
      json['LastCommittedTxn'] == null ? undefined : json['LastCommittedTxn'],
    name: json['Name'] == null ? undefined : json['Name'],
    options: json['Options'] == null ? undefined : json['Options'],
    replicationLag:
      json['ReplicationLag'] == null ? undefined : json['ReplicationLag'],
    requestedPrimariesCount:
      json['RequestedPrimariesCount'] == null
        ? undefined
        : json['RequestedPrimariesCount'],
    requestedPropertyShardReplicas:
      json['RequestedPropertyShardReplicas'] == null
        ? undefined
        : json['RequestedPropertyShardReplicas'],
    requestedSecondariesCount:
      json['RequestedSecondariesCount'] == null
        ? undefined
        : json['RequestedSecondariesCount'],
    requestedStatus:
      json['RequestedStatus'] == null ? undefined : json['RequestedStatus'],
    role: json['Role'] == null ? undefined : json['Role'],
    serverID: json['ServerID'] == null ? undefined : json['ServerID'],
    statusMessage:
      json['StatusMessage'] == null ? undefined : json['StatusMessage'],
    store: json['Store'] == null ? undefined : json['Store'],
    type: json['Type'] == null ? undefined : json['Type'],
    writer: json['Writer'] == null ? undefined : json['Writer'],
  };
}

export function V1ShowDatabasesStatusToJSON(json: any): V1ShowDatabasesStatus {
  return V1ShowDatabasesStatusToJSONTyped(json, false);
}

export function V1ShowDatabasesStatusToJSONTyped(
  value?: V1ShowDatabasesStatus | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    Access: value['access'],
    Address: value['address'],
    Aliases: value['aliases'],
    CurrentPrimariesCount: value['currentPrimariesCount'],
    CurrentPropertyShardReplicas: value['currentPropertyShardReplicas'],
    CurrentSecondariesCount: value['currentSecondariesCount'],
    CurrentStatus: value['currentStatus'],
    DatabaseID: value['databaseID'],
    Default: value['_default'],
    Home: value['home'],
    LastCommittedTxn: value['lastCommittedTxn'],
    Name: value['name'],
    Options: value['options'],
    ReplicationLag: value['replicationLag'],
    RequestedPrimariesCount: value['requestedPrimariesCount'],
    RequestedPropertyShardReplicas: value['requestedPropertyShardReplicas'],
    RequestedSecondariesCount: value['requestedSecondariesCount'],
    RequestedStatus: value['requestedStatus'],
    Role: value['role'],
    ServerID: value['serverID'],
    StatusMessage: value['statusMessage'],
    Store: value['store'],
    Type: value['type'],
    Writer: value['writer'],
  };
}
